<template>
  <section class="curation-data-sources">
    <CurationHeader />
    <div class="is-flex is-align-items-center">
      <div class="is-flex is-align-items-center mb-4"></div>
      <form @submit.prevent="checkCsid(csidValue)">
        <div>ChemSpider ID</div>
        <input
          type="text"
          v-model="csidValue"
          class="mb-4"
          style="border: 1px solid #cccccc; border-radius: 4px; padding: 0 7px; height: 40.35px; width: 400px; font-size: 1em"
        />
      </form>
      <div>
        <button class="button ml-3" @click="checkCsid(csidValue)" style="margin-top:7px">
          Get record
        </button>
      </div>
      <div style="margin-left: 200px">
        <div>Data sources</div>
        <v-select
          v-model="selectedDatasource"
          :options="datasourceNames"
          :placeholder="datasourceNames.length > 0 ? 'Select a datasource' : 'No datasources loaded'"
          class="mb-4"
          style="width: 400px;"
          @input="onDatasourceSelected"
        />
      </div>
    </div>
    <div v-if="searchedCSID && noDataFound && !loading">Sorry, no data was found for CSID: {{searchedCSID}}</div>
    <div v-else-if="searchedCSID && !noDataFound && !loading">Found data on: {{searchedCSID}}</div>    
    <div v-if="removalMessages.length > 0" class="mt-3">
      <div v-for="removalMessage, index of removalMessages" :key="index" class="is-flex is-justify-content-flex-end">
        <div :class="removalMessage.removed ? 'has-text-success' : 'has-text-danger'">
          {{ removalMessage.message }}
        </div>
      </div>
    </div>
    <div class="mt-6">
      <div class="is-flex is-justify-content-flex-end" v-if="datasourcesByName.length > 0">
        <button class="button" @click="allSelected ? deSelectAll() : selectAll()">
          {{ allSelected ? 'Deselect All' : 'Select All' }}
        </button>
      </div>
      <table v-if="datasourcesByName.length > 0" style="width: 100%; word-break: break-all;">
          <thead>
            <tr>
              <th class="has-text-weight-bold custom-font-size-18"
              style="padding: 14px 22px; white-space: nowrap">Ext id</th>
              <th class="has-text-weight-bold custom-font-size-18"
              style="padding: 14px 22px; white-space: nowrap">Ext url</th>
              <th class="has-text-weight-bold custom-font-size-18"
              style="padding: 14px 22px; white-space: nowrap"></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="datasource, index of datasourcesByName" :key="index">
              <td class="is-size-6" style="padding: 35px 15px">{{ datasource.ExternalId }}</td>
              <td class="is-size-6" style="padding: 35px 15px"><a :href="datasource.ExternalUrl" target="">{{ datasource.ExternalUrl }}</a></td>
              <td class="is-size-6 has-text-centered" style="padding: 35px 15px"  ><input type="checkbox" :checked="markedDatasources.includes(datasource.ExternalId)" @change="groupedExternalIds(datasource.ExternalId, $event.target.checked)"/></td>
            </tr>         
          </tbody>
      </table>
      <div class="is-flex is-justify-content-flex-end" v-if="datasourcesByName.length > 0">
        <button class="button" @click="deleteDatasourceEntries">Delete</button>
      </div>    
    </div>

  </section>
</template>

<script>
import CurationHeader from "@/components/curation/shared/header.vue";
import { ChemspiderDataService } from "@/api";
export default {
  components: { CurationHeader },
  name: 'CurationDataSources',
  data() {
    return {
      loading: false,
      datasources: [],
      csidValue: '',
      groupedDatasources: {},
      datasourceNames: [],
      selectedDatasource: '',
      selectedDatasourceId: '',
      noDataFound: false,
      searchedCSID: 0,
      datasourcesByName: [],
      markedDatasources: [],
      removalMessages: [],
      justDeleted: false
    };
  },
  computed: {
    allSelected() {
      const currentIds = this.datasourcesByName.map(ds => ds.ExternalId);
      return currentIds.length > 0 && currentIds.every(id => this.markedDatasources.includes(id));
    }
  },
  methods: {
    async checkCsid(csidValue) {
      this.loading = true;
      if (!this.justDeleted) this.selectedDatasource = '';
      if (!this.justDeleted) this.selectedDatasourceId = '';      
      this.datasourcesByName = [];
      this.markedDatasources = [];
      this.noDataFound = false;
      this.searchedCSID = csidValue;
      this.datasourceNames = [];
      const grouped = {};
      if (!this.justDeleted) this.removalMessages = [];
      this.datasources = await ChemspiderDataService.getDatasourcesById(csidValue);
      // Verifies if no data was found
      if (!this.datasources?.Data || this.datasources.Data.length === 0) {        
        this.noDataFound = true;
        this.loading = false;
        return;
      } else {
        this.datasources.Data.forEach((item) => {
          const name = item.Name;
          if (!grouped[name]) {
            grouped[name] = [];
          }
          grouped[name].push(item);
        });
        this.groupedDatasources = grouped;
        this.datasourceNames = Object.keys(grouped)
        this.loading = false;
      }
        
    }, 
    onDatasourceSelected() {
      if (!this.justDeleted) this.removalMessages = [];
      this.justDeleted = false
      this.datasourcesByName = [];
      this.markedDatasources = [];
      
      this.datasources.Data.forEach((item) => {
        const name = item.Name;
        if (name == this.selectedDatasource) {
          this.datasourcesByName.push(item);
        }
      });

      if (this.datasourcesByName[0]) {
        this.selectedDatasourceId = this.datasourcesByName[0].DatasourceId;
      }
    },
    groupedExternalIds(externalId, checked) {
      if (checked) {
        this.markedDatasources.push(externalId);
      } else {
        this.markedDatasources = this.markedDatasources.filter(id => id !== externalId);
      }
    },
    selectAll() {
      this.markedDatasources = this.datasourcesByName.map(ds => ds.ExternalId);
    },
    deSelectAll() {
      this.markedDatasources = [];
    },
    async deleteDatasourceEntries () {
      this.removalMessages = [];
      let response
      if (this.allSelected) {
        try {
          response = await ChemspiderDataService.deleteDatasource(this.searchedCSID, this.selectedDatasourceId);
          if (response.Data.Message?.includes("removed successfully")) {
              this.removalMessages.push({message: `Datasource ${this.selectedDatasource} removed succesfully`, removed: true})
              this.markedDatasources = [];
              // We do a new api call to update the frontend
              this.justDeleted = true;
              await this.checkCsid(this.searchedCSID)
              this.selectedDatasource = '';
              this.selectedDatasourceId = '';
              this.justDeleted = false;            
          } else {
            console.warn(`Failed to delete ${this.selectedDatasourceId}`);
            this.removalMessages.push({message: `Failed to remove datasource ${this.selectedDatasource}`, removed: false})
          }
        } catch (error) {
            console.error(`Error deleting ${this.selectedDatasourceId}:`, error);
        }
      } else {
        for (let datasourceEntry of this.markedDatasources) {
          try {
            response = await ChemspiderDataService.deleteDatasourceEntry(this.searchedCSID, this.selectedDatasourceId, datasourceEntry);
            if (response.Data.Message?.includes("removed successfully")) {
              this.removalMessages.push({message: `Entry ${datasourceEntry} removed successfully`, removed: true})
              
              this.markedDatasources = this.markedDatasources.filter(
                id => id !== datasourceEntry
              );
            } else {
              console.warn(`Failed to delete ${datasourceEntry}`);
              this.removalMessages.push({message: `Failed to remove entry ${datasourceEntry}`, removed: false})
            }
          } catch (error) {
            console.error(`Error deleting ${datasourceEntry}:`, error);
          }            
        }
        // We do a new api call to update the frontend
        this.justDeleted = true;
        await this.checkCsid(this.searchedCSID);
        await this.onDatasourceSelected()
      }
    },
  }
};
</script>

<style lang="scss" scoped>

thead th {
  min-width: 170px
}

tbody tr:nth-child(even) {
  background-color: #f9f9f9;
}

input[type="checkbox"] {
  width: 20px;
  height: 20px
}
</style>
  